export const gpaTabMeta = {
  id: "gpa",
  label: "Tính GPA",
  shortLabel: "GPA",
};
